import { SET_ASSET_UPDATED_BY_DART, CLEAN_WAS_DART_UPDATED } from "../constants/middleView-types"


export const setAssetUpdatedByDart = (updatedAssetId) => {

    return dispatch => {
        dispatch({ type: SET_ASSET_UPDATED_BY_DART, payload: { updatedAssetId } })
    }
}


export const cleanWasDartUpdated = () => {


    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch({ type: CLEAN_WAS_DART_UPDATED })
            resolve()
        })

    }
}